module.exports = __webpack_public_path__ + "img/logo2.d2db7e2b.jpg";